const uiModule = {
  state: {
    scrollPos: 0,
    isScrolling: false,
    activeMapOnLocation: false,
    searchGridScrollPos: 0
  },
  mutations: {
    setScrollPos (state, payload) {
      state.isScrolling = (state.scrollPos > payload - 65 && state.scrollPos < payload + 65)
      state.scrollPos = payload
      state.activeMapOnLocation = false
    },
    setActiveMapOnLocation (state, payload) {
      state.activeMapOnLocation = payload
    },
    setSearchGridScrollPos (state, payload) {
      state.searchGridScrollPos = payload
    }
  },
  actions: {
    setScrollPos (context, payload) {
      console.log('setScrollPos', payload)
      context.commit('setScrollPos', payload)
    },
    setActiveMapOnLocation (context, payload) {
      context.commit('setActiveMapOnLocation', payload)
    },
    setSearchGridScrollPos (context, payload) {
      context.commit('setSearchGridScrollPos', payload)
    }
  },
  getters: { }
}

export default uiModule
